var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Star",
    clipPath: "url(#clip0_305_94564)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Star_2",
    d: "M9.57668 2.71993C9.91827 1.89864 11.0817 1.89864 11.4233 2.71993L12.9105 6.29546C13.0545 6.6417 13.3801 6.87827 13.7539 6.90823L17.614 7.2177C18.5006 7.28878 18.8601 8.39529 18.1846 8.97396L15.2436 11.4932C14.9588 11.7372 14.8345 12.1199 14.9215 12.4847L15.82 16.2515C16.0264 17.1167 15.0851 17.8006 14.326 17.3369L11.0213 15.3184C10.7012 15.1229 10.2988 15.1229 9.97875 15.3184L6.67397 17.3369C5.91487 17.8006 4.97362 17.1167 5.18001 16.2515L6.07852 12.4847C6.16553 12.1199 6.04116 11.7372 5.75637 11.4932L2.81539 8.97396C2.13985 8.39529 2.49938 7.28878 3.38603 7.2177L7.24612 6.90823C7.61991 6.87827 7.94552 6.6417 8.08953 6.29546L9.57668 2.71993Z",
    fill: "#4F4770"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_305_94564"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRounded);
export default __webpack_public_path__ + "static/media/StarRounded.60292fd77150993c3916024bf452eb50.svg";
export { ForwardRef as ReactComponent };